import { L24, L40, defaultTheme } from "@adfenix/alexandria";
import { StylesConfig } from "react-select";

const backgroundColor = "#050b1f";
const color = "white";

/**
 * Dark theme that can be passed into a react select component or the
 * Alexandria Combobox. The Alexandria Combobox contains some defualt styling
 * and this is an override of those styles with a dark theme.
 */
export const reactSelectDark: StylesConfig = {
  control: (base, state) => ({
    ...base,
    backgroundColor,
    color,
    boxShadow: "none",
    borderColor: state.isFocused
      ? defaultTheme.colors.primary
      : L40(defaultTheme.colors.grey),
    "&:hover": {
      borderColor: state.isFocused
        ? defaultTheme.colors.primary
        : L24(defaultTheme.colors.grey)
    },
    "&:active": {
      borderColor: defaultTheme.colors.primary,
      outline: "none"
    },
    "&:focus": {
      borderColor: defaultTheme.colors.primary,
      outline: "none"
    },

    borderRadius: "4px",
    opacity: state.isDisabled ? 0.4 : 1,
    transition: "opacity 300ms"
  }),

  indicatorSeparator: () => ({
    background: "none"
  }),
  dropdownIndicator: base => ({
    ...base,
    paddingRight: "16px"
  }),
  menu: args => ({
    ...args,
    backgroundColor,
    color,
    border: `1px solid ${L40(defaultTheme.colors.grey)}`
  }),
  input: base => ({
    ...base,
    color
  }),
  singleValue: base => ({
    ...base,
    color
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused
      ? defaultTheme.colors.primary
      : backgroundColor
  })
};
